module.exports = __webpack_public_path__ + "static/media/header-mail.99496403.svg";